module.exports = __webpack_public_path__ + "static/media/qab_services_ios.e8e9f1d3.png";